import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['tiny', 'tiny+', 'xs+', 'sm+'] }]
    }
  }
})

export const cn = (...inputs: ClassValue[]): string => {
  return twMerge(clsx(inputs))
}
